var map = {
	"./diamond.png": "0c9b",
	"./hand.png": "b52b",
	"./heart.png": "02f7",
	"./hot.png": "874d",
	"./medal.png": "511a",
	"./star.png": "36ca",
	"./timer.png": "55f3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8d54";